import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ScoreParamsPageUI from './ScoreParamsPageUI.js'

class ScoreParamsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      errorList: null,
      parameterList: null,
      provisionalYear: null,
      //
      showUnused: false,
      showAllYears: false,
      //
      updateMode: false,
      updateProvisionalsMode: false,
      //
      parameterName: '',
      financialYear: '',
      parameterValue: '',
      //
      editable: false,
      itrMode: false,
      stpMode: false,
    }
  }

  render() {
    return (
      <ScoreParamsPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        params={this.state.parameterList}
        provisionalYear={this.state.provisionalYear}
        onRefreshClick={this.onRefreshClick}
        //
        showUnused={this.state.showUnused}
        onShowUnusedCick={() => { this.setState({ showUnused: true }) }}
        onHideUnusedCick={() => { this.setState({ showUnused: false }) }}
        allYrs={this.state.showAllYears}
        onShowAllClick={() => { this.setState({ showAllYears: true }) }}
        onShowRecentClick={() => { this.setState({ showAllYears: false }) }}
        //
        updateMode={this.state.updateMode}
        updClk={this.onUpdateClick}
        onCancelClick={() => { this.setState({ parameterValue: '', updateMode: false }) }}
        onUpdate={this.onUpdate}
        updateProvisionalsMode={this.state.updateProvisionalsMode}
        onUpdateProvisionals={this.onUpdateProvisionals}
        parameterName={this.state.parameterName}
        financialYear={this.state.financialYear}
        parameterValue={this.state.parameterValue}
        //
        toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
        edit={this.state.editable}
        onToggleMcaItr={() => { this.setState({ itrMode: !this.state.itrMode }) }}
        itr={this.state.itrMode}
        onToggleClassicStp={() => { this.setState({ stpMode: !this.state.stpMode }) }}
        stp={this.state.stpMode}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getScoreParameters(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getScoreParameters(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/scoreParameters`,
      cacheKey: CacheKeys.ScoreParameters(this.props.match.params.accountId),
      callback: this.getScoreParametersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getScoreParametersCallback = (response) => {
    response.parameterList.map(param => {
      if (param.companyCreditRating)
        if (param.companyCreditRating === 100)
          param.companyCreditRating = 'NR'
        else
          param.companyCreditRating = 'CMR-' + param.companyCreditRating
    })
    this.setState({
      errorList: response.errorList, parameterList: response.parameterList,
      provisionalYear: response.provisionalYear
    })
  }

  onUpdateClick = (event) => {
    let parameterValue = event.currentTarget.getAttribute('data-value')
    if (!parameterValue) // in case null, pass empty string
      parameterValue = ''
    else {
      parameterValue = parameterValue.replace('₹', '')
      parameterValue = parameterValue.replaceAll(',', '')
    }

    this.setState({
      parameterName: event.currentTarget.getAttribute('data-name'),
      financialYear: event.currentTarget.getAttribute('data-year'),
      parameterValue: parameterValue,
      updateMode: true
    })
  }

  onUpdate = (parameterValue) => {
    let row = this.state.parameterList.filter(p => p.financialYear === this.state.financialYear)[0]
    row[this.state.parameterName] = parameterValue
    this.setState({
      parameterList: this.state.parameterList
    })
  }

  onUpdateProvisionals = () => {
    if (this.state.updateProvisionalsMode)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      updateProvisionalsMode: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreParameters/provisionals`,
      this.onUpdateProvisionalsCallback, {}
    )
  }

  onUpdateProvisionalsCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      updateProvisionalsMode: false
    })

    if (response.errorList.length === 0) {
      this.getScoreParameters(this.props.context)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 2000)
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.ScoreParameters(this.props.match.params.accountId))
    this.setState({
      account: null,
      parameterList: null,
      errorList: null,
    },
      this.getAccounts(this.props.context),
      this.getScoreParameters(this.props.context)
    )
  }
}

export default withRouter(ScoreParamsPageSF)
